import { render, staticRenderFns } from "./currentConfigTitle.vue?vue&type=template&id=8038a050&scoped=true&"
import script from "./currentConfigTitle.vue?vue&type=script&lang=ts&"
export * from "./currentConfigTitle.vue?vue&type=script&lang=ts&"
import style0 from "./currentConfigTitle.vue?vue&type=style&index=0&id=8038a050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8038a050",
  null
  
)

export default component.exports